import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type StageRepullPartnersResponse = {
  stagedAt: string;
};

// POST /api/settings/integrations/hubspot/repull-partners
//
// Marker mutation — the actual re-pull runs out-of-band (vendor ops script)
// until Session 10 ports it to an Edge Function. Response carries an ISO
// timestamp the SPA stores as the "Last queued: …" breadcrumb.
export function useStageRepullPartners() {
  const queryClient = useQueryClient();
  return useMutation<StageRepullPartnersResponse, ApiClientError, void>({
    mutationFn: () =>
      apiFetch<StageRepullPartnersResponse>(
        "/settings/integrations/hubspot/repull-partners",
        { method: "POST" },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.integrations() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to queue re-pull");
    },
  });
}
